import { Link } from "react-router-dom";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from '../../assets/logo.png';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is imported

function Navbarr() {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  const handleNavLinkClick = (sectionId) => {
    setExpanded(false);
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 80, // Adjust for navbar height
        behavior: 'smooth'
      });
    }
  };

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      style={{ position: "fixed", width: "100%", top: 0, zIndex: 1000, boxShadow: "none", backgroundColor: "var(--white)" }}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
          <img src={logo} style={{width:"190px",height:"100px"}}/>
        </Navbar.Brand>
        
        <div className="navbar-toggle" onClick={handleToggle}>
          {expanded ? <FaTimes size={24} color="var(--primary)" /> : <FaBars size={24} color="var(--primary)" />}
        </div>
        
        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto my-2 my-lg-0 nav-items" navbarScroll>
            <Nav.Link onClick={() => handleNavLinkClick('home')}>
              Home
            </Nav.Link>
            <Nav.Link onClick={() => handleNavLinkClick('about-us')}>
              About Us
            </Nav.Link>
            <Nav.Link onClick={() => handleNavLinkClick('how-it-works')}>
              How it works
            </Nav.Link>
          </Nav>
          <Form className="d-flex nav-login-btn">
            <button
              className="button-37 nav-login"
              style={{ border: "2px solid var(--primary)", color: "var(--white)" }}
            >
                 <Link to={"/login"} style={{ color: "white", textDecoration: "none" }}>
             Login
            </Link>
            </button>
          </Form>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navbarr;
